import m from '@bitstillery/mithril'
import {api, config} from '@bitstillery/common/app'
import {
    AsyncData,
    Band,
    Bento,
    Button,
    Card,
    CmsLink,
    Column,
    Dropdown,
    FieldCheckbox,
    FieldCode,
    FieldCurrency,
    FieldDate,
    FieldEditor,
    FieldListInput,
    FieldMoney,
    FieldNumber,
    FieldProduct,
    FieldRadio,
    FieldRadioSelection,
    FieldSearch,
    FieldSelect,
    FieldSelectMany,
    FieldSwitch,
    FieldText,
    FieldTextArea,
    FieldTime,
    FieldUpload,
    Fieldset,
    Grid,
    Heading,
    HeroBand,
    Icon,
    Image,
    List,
    MarqueeStrip,
    Notifier,
    Paragraph,
    PlaceholderCard,
    ProfileCard,
    PromoCard,
    Quote,
    QuoteCard,
    Section,
    Stat,
    Text,
    Well,
} from '@bitstillery/common/components/portal'
import {media_folder_file_src, pick_daily_file} from '@bitstillery/common/cms/lib/media'
import {offer_hash_from_artkey} from '@bitstillery/common/lib/offer_hash'
import {cms_key_slug, get_route, shuffle_array, slugify} from '@bitstillery/common/lib/utils'

import {$t} from '@bitstillery/common/app'
import {$s} from '@/app'
import {require_login} from '@/components/auth/require_login'
import {Products} from '@/cms/components/products/products'
import {FunFacts} from '@/cms/components/footer/fun_facts'
import {CmsFragment} from '@/cms/runtime/fragments'
import {CmsPopupDialog} from '@/cms/components/popup/popup'
import {popup_dismiss} from '@/cms/lib/popup'

function portal_session_authenticated(): boolean {
    return Boolean($s.identity.token)
}

/** Groups top-level siblings without a wrapper element — the `<>…</>` fragment. */
const Fragment = {view: (vnode: m.Vnode<unknown>) => vnode.children}

/** Catalog keys sorted alphabetically (matches `jsx_runtime_shim` destructure order). */
export function register_cms_catalog(): void {
    globalThis.__CMS_CATALOG__ = {
        $s,
        $t,
        api,
        AsyncData,
        Band,
        Bento,
        Button,
        Card,
        cms_key_slug,
        CmsFragment,
        Column,
        config,
        Dialog: CmsPopupDialog,
        Dropdown,
        FieldCheckbox,
        FieldCode,
        FieldCurrency,
        FieldDate,
        FieldEditor,
        FieldListInput,
        FieldMoney,
        FieldNumber,
        FieldProduct,
        FieldRadio,
        FieldRadioSelection,
        FieldSearch,
        FieldSelect,
        FieldSelectMany,
        FieldSwitch,
        FieldText,
        FieldTextArea,
        FieldTime,
        FieldUpload,
        Fieldset,
        Fragment,
        FunFacts,
        get_route,
        Grid,
        Heading,
        HeroBand,
        Icon,
        Image,
        Link: CmsLink,
        List,
        MarqueeStrip,
        m,
        media_folder_file_src,
        Notifier,
        offer_hash_from_artkey,
        Paragraph,
        pick_daily_file,
        PlaceholderCard,
        Products,
        ProfileCard,
        PromoCard,
        popup_dismiss,
        portal_session_authenticated,
        Quote,
        QuoteCard,
        require_login,
        Section,
        shuffle_array,
        slugify,
        Stat,
        Text,
        Well,
    }
}
